@if (readonly) {
    <div class="row">
        <div class="col-12 mb-4 form-container">
            <div class="options-form options-form--header">
                <div class="row">
                    <div class="col-sm-6 mb-2 mb-2">
                        <p>{{ title }}</p>
                    </div>
                </div>
            </div>
            <div class="options-form">
                <div class="row">
                    <div class="col-12 mb-2">
                        <ng-container *ngTemplateOutlet="documentTable"></ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
} @else {
    <div class="options-form options-form--header">
        <div class="row">
            <div class="col-12">
                <p>{{ title }}</p>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <ng-container *ngTemplateOutlet="documentTable"></ng-container>
        </div>
    </div>
}

<ng-template #documentTable>
    <mat-table [dataSource]="documents">
        @if (readonly) {
            <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef>
                    <span>{{ 'shared.miscellaneous.name' | translate }}</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <span class="downloadable-link" (click)="download.emit(element)">{{ element.name }}</span>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="createdAt">
                <mat-header-cell *matHeaderCellDef>
                    <span>{{ 'sales-activity.properties.last-changed' | translate }}</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{ element.updatedAt | localizedDate }}
                </mat-cell>
            </ng-container>
            @if (categorySelectable) {
                <ng-container matColumnDef="category">
                    <mat-header-cell *matHeaderCellDef>
                        <i class="material-icons">label</i>
                        <span>{{ 'projects.project-detail.commercials.document-category.action' | translate }}</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        @if (element.category) {
                            <span class="category-tag">
                                {{
                                    'projects.project-detail.commercials.document-category.' +
                                        categoryI18nKeys[element.category] | translate
                                }}
                            </span>
                        }
                    </mat-cell>
                </ng-container>
            }
        } @else {
            <ng-container matColumnDef="fileName">
                <mat-header-cell *matHeaderCellDef>
                    <span>{{ 'shared.miscellaneous.name' | translate }}</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <span class="downloadable-link" (click)="download.emit(element)">{{ element.name }}</span>
                </mat-cell>
            </ng-container>
            @if (categorySelectable) {
                <ng-container matColumnDef="category">
                    <mat-header-cell *matHeaderCellDef>
                        <i class="material-icons">label</i>
                        <span>{{ 'projects.project-detail.commercials.document-category.action' | translate }}</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <button type="button" mat-button [matMenuTriggerFor]="categoryMenu">
                            @if (element.category) {
                                {{
                                    'projects.project-detail.commercials.document-category.' +
                                        categoryI18nKeys[element.category] | translate
                                }}
                            } @else {
                                {{ 'projects.project-detail.commercials.document-category.action' | translate }}
                            }
                        </button>
                        <mat-menu #categoryMenu="matMenu">
                            @for (category of categories; track category) {
                                <button
                                    type="button"
                                    mat-menu-item
                                    (click)="categoryChanged.emit({ id: element.id, category })"
                                >
                                    {{
                                        'projects.project-detail.commercials.document-category.' +
                                            categoryI18nKeys[category] | translate
                                    }}
                                </button>
                            }
                        </mat-menu>
                    </mat-cell>
                </ng-container>
            }
            @if (showArchiveAction) {
                <ng-container matColumnDef="archive">
                    <mat-header-cell *matHeaderCellDef>
                        <i class="material-icons">archive</i>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <button type="button">
                            <i (click)="archive.emit(element)" class="material-icons">archive</i>
                        </button>
                    </mat-cell>
                </ng-container>
            }
            @if (showDeleteAction) {
                <ng-container matColumnDef="delete">
                    <mat-header-cell *matHeaderCellDef>
                        <i class="material-icons">delete</i>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <button type="button">
                            <i (click)="delete.emit(element)" class="material-icons">delete</i>
                        </button>
                    </mat-cell>
                </ng-container>
            }
        }
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
</ng-template>
